module.exports = "//d274d294w9cx2v.cloudfront.net/f62256d543ac5d8b007021a0dd33687c4ee07523/images/digital-invites.jpg";